import React from "react";
import { withStableUniqueId } from "react-stable-uniqueid";
import styles from "./Key.css";

import { BOX_SIZE } from "../../constants";

const Key = ({ char, uniqueId }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${BOX_SIZE} ${BOX_SIZE + 1.62}`}
    preserveAspectRatio="xMidYMid meet"
    className={styles.key}
  >
    <defs>
      <linearGradient
        id={`${uniqueId}-linear-gradient`}
        x1="25.03"
        y1="-0.28"
        x2="24.98"
        y2="50.08"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f8f8f8" />
        <stop offset="0.75" stopColor="#ebebeb" />
        <stop offset="0.88" stopColor="#e9e9e9" />
        <stop offset="0.93" stopColor="#e2e2e2" />
        <stop offset="0.97" stopColor="#d5d5d5" />
        <stop offset="1" stopColor="#c9c9c9" />
      </linearGradient>
    </defs>
    <rect
      y="1.62"
      width="50"
      height="50"
      rx="5"
      ry="5"
      fill="#443829"
      opacity="0.5"
    />
    <rect
      width="50"
      height="50"
      rx="5"
      ry="5"
      fill={`url(#${uniqueId}-linear-gradient)`}
    />
    <text
      x={BOX_SIZE / 2}
      y={BOX_SIZE / 2}
      fontFamily="curse_casual, comic sans ms, sans-serif"
      fontSize="40"
      textAnchor="middle"
      dominantBaseline="central"
    >
      {char}
    </text>
  </svg>
);

export default withStableUniqueId()(Key);



// WEBPACK FOOTER //
// ./src/components/Keyboard/Key.js